<template>
  <div id="OrgAccount">
    <eb-header>
      <eb-break-crumb slot="breakCrumb" />
    </eb-header>
    <div class="account-page">
      <div class="dept-tree">
        <DeptTree />
      </div>
      <div class="dept-user">
        <DeptUser />
      </div>
    </div>
    <AddAndEditDept />
    <AddUser/>
    <SetUserStatus />
  </div>
</template>
<script>
import ebHeader from '@/components/common/eb-header';
import ebBreakCrumb from '@/components/common/eb-break-crumb';
import DeptTree from '@/components/org/account/DeptTree';
import DeptUser from '@/components/org/account/DeptUser';
import AddAndEditDept from '@/components/org/account/AddAndEditDept';
import AddUser from '@/components/org/account/AddUser';
import SetUserStatus from '@/components/org/account/SetUserStatus';
export default {
  name: 'OrgAccount',
  components: {
    ebHeader,
    ebBreakCrumb,
    DeptTree,
    DeptUser,
    AddAndEditDept,
    AddUser,
    SetUserStatus
  },
  created() {}
};
</script>
<style scoped lang="less">
#OrgAccount {
  .account-page {
    width: 100%;
    margin-left: 0px;
    margin-top: 30px;
    display: flex;
    flex-wrap: wrap;
    .dept-tree {
      width: 23%;
      margin-right: 10px;
      margin-left: 10px;
    }
    .dept-user {
      width: 73%;
      margin-left: 10px;
      margin-right: 10px;
    }
  }
}
</style>
